export enum ELEMENT_TYPES {
    TEXT_ELEMENT = 'TEXT_ELEMENT',
    VIDEO_ELEMENT = 'VIDEO_ELEMENT',
    TEST_ELEMENT = 'TEST_ELEMENT',
    FILE_ELEMENT = 'FILE_ELEMENT',
    IMAGE_ELEMENT = 'IMAGE_ELEMENT',
    CASE_ELEMENT = 'CASE_ELEMENT'
}
